import store from "../redux";
import { clearAccessToken } from "../lib/authToken";
import { oktaAuth } from "./oktaConfig";
import { clearStaleAuthTokens } from "./oktaTokens";

const SESSION_KEYS = [
  "currentUser",
  "rememberMe",
  "username",
  "password",
  "accessToken",
  "idToken",
  "oktaAccessToken",
  "persist:root",
  "refreshToken",
  "user",
  "serviceProviderId",
  "authenticationResult",
];

export async function oktaSignOut() {
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  clearStaleAuthTokens();
  store.dispatch({ type: "LOGOUT" });
  clearAccessToken();

  try {
    await oktaAuth.revokeAccessToken();
  } catch {
    // Token may already be cleared.
  }

  try {
    await oktaAuth.signOut({
      postLogoutRedirectUri:
        import.meta.env.VITE_OKTA_POST_LOGOUT_REDIRECT_URI || `${window.location.origin}/logout`,
    });
  } catch {
    oktaAuth.tokenManager.clear();
    window.location.replace("/login");
  }
}
